// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function getFormErrors(field, value) {
    value = String(value);
    return {
        required: "".concat(field, " ist ein Pflichtfeld."),
        numbers: "".concat(field, " darf nur Zahlen enthalten."),
        notNumbers: "".concat(field, " darf keine Zahlen enthalten."),
        notSpecialCharactersForNames: "".concat(field, " darf keine Sonderzeichen enthalten."),
        email: "E-Mail hat nicht das richtige Format f\u00FCr eine E-Mail-Adresse.",
        agreementNotApplied: "Bitte stimmen Sie zu.",
        phonePhoneCode: "Mobilnummer muss mit einer 0 beginnen und darf nur Zahlen enthalten. Bitte keine Landesvorwahl angeben, z. B. +49.",
        minLength: "".concat(field, " muss mindestens ").concat(value, " Zeichen lang sein."),
        maxLength: "".concat(field, " muss h\u00F6chstens ").concat(value, " Zeichen haben."),
        dateAfter: "".concat(field, " ist zu fr\u00FCh"),
        dateBefore: "Um einen Kredit aufnehmen zu k\u00F6nnen, m\u00FCssen Sie mindestens ".concat(value, " Jahre alt sein."),
        requiredDate: "Bitte geben Sie hier ein g\u00FCltiges Datum ein.",
        invalidDate: "".concat(field, " ist kein g\u00FCltiges Datum."),
        requiredPhoneNo: "Bitte geben Sie eine g\u00FCltige Mobilnummer ein.",
        phonePhoneLength: "Mobilnummer muss mindestens 8 und darf h\u00F6chstens 15 Ziffern enthalten.",
        phoneIsNotValid: 'Bitte geben Sie eine gültige Telefonnummer an.',
        minValue: "".concat(field, " muss mindestens ").concat(value, " \u20AC betragen."),
        maxValue: "".concat(field, " darf h\u00F6chstens ").concat(value, " \u20AC betragen."),
    };
}
